import defaultAxios from './axios.js';
export const axios = defaultAxios;
